module.exports = __webpack_public_path__ + "img/dhz.8c6e4bf1.png";